// import React, { useEffect, useState } from "react";
// import { toast } from "react-toastify";
// import {
//   Table,
//   TableHeader,
//   TableColumn,
//   TableBody,
//   TableRow,
//   TableCell,
//   Input,
//   Button,
//   Chip,
//   User,
//   Pagination,
//   useDisclosure,
// } from "@nextui-org/react";
// import axios from "axios";
// import { IoSearchOutline } from "react-icons/io5";
// import AccessModal from "./AccessModal";

// export function capitalize(s) {
//   return s ? s.charAt(0).toUpperCase() + s.slice(1).toLowerCase() : "";
// }

// export const columns = [
//   { name: "ID", uid: "id", sortable: true },
//   { name: "NAME", uid: "name" },
//   { name: "ROLE", uid: "role" },
//   { name: "EMAIL", uid: "email" },
//   { name: "PHONE", uid: "phone" },
//   { name: "CAPRICORN", uid: "capricorn" },
//   { name: "COMPANY", uid: "company" },
//   { name: "STATUS", uid: "status" },
//   { name: "ACTIONS", uid: "actions" },
// ];

// export const statusOptions = [
//   { name: "PENDING", uid: "PENDING" },
//   { name: "APPROVED", uid: "APPROVED" },
//   { name: "REJECTED", uid: "REJECTED" },
// ];

// const statusColorMap = {
//   PENDING: "success",
//   APPROVED: "bg-green-600",
//   REJECTED: "bg-red-500",
// };

// const INITIAL_VISIBLE_COLUMNS = [
//   "name",
//   "role",
//   "phone",
//   "capricorn",
//   "company",
//   "actions",
// ];

// export default function RequestApproval() {
//   const [text, setText] = useState("");
//   const [userLists, setUserLists] = useState([]);
//   const { isOpen, onOpen, onClose } = useDisclosure();
//   const [selectedUser, setSelectedUser] = useState(null);
//   const [paginationData, setPaginationData] = useState({
//     currentPage: 1,
//     limit: 10,
//     totalPages: 1,
//     hasNextPage: false,
//     hasPrevPage: false,
//     totalRecords: 1,
//   });
//   const [filterValue, setFilterValue] = React.useState("");
//   const [visibleColumns, setVisibleColumns] = React.useState(
//     new Set(INITIAL_VISIBLE_COLUMNS)
//   );
//   const [rowsPerPage, setRowsPerPage] = React.useState(6);
//   const [sortDescriptor, setSortDescriptor] = React.useState({
//     column: "age",
//     direction: "ascending",
//   });

//   const [page, setPage] = React.useState(1);

//   const hasSearchFilter = Boolean(filterValue);

//   const headerColumns = React.useMemo(() => {
//     if (visibleColumns === "all") return columns;

//     return columns.filter((column) =>
//       Array.from(visibleColumns).includes(column.uid)
//     );
//   }, [visibleColumns]);

//   const handleSubmit = async () => {
//     try {
//       let access = text === "Approve" ? "APPROVED" : "REJECTED";
//       let data = {
//         approval_status: access,
//       };
//       let res = await axios.put(
//         `${process.env.REACT_APP_SERVER_URL}/admin/updatesupplierapproval/${selectedUser.id}`,
//         data
//       );
//       if (res) {
//         getAllUsers();
//         onClose();
//       }
//     } catch (error) {
//       console.log(error);
//       toast.error(error.response.data.message);
//     }
//   };

//   const handleModal = (item, text) => {
//     setSelectedUser(item);
//     setText(text);
//     onOpen();
//   };

//   const filteredItems = React.useMemo(() => {
//     let filteredUsers = [...userLists];
//     if (hasSearchFilter) {
//       filteredUsers = filteredUsers.filter((user) => {
//         const fullName = `${user.first_name} ${user.last_name}`.toLowerCase();
//         return fullName.includes(filterValue.toLowerCase());
//       });
//     }
//     return filteredUsers;
//   }, [userLists, filterValue]);

//   const items = React.useMemo(() => {
//     const start = (page - 1) * rowsPerPage;
//     const end = start + rowsPerPage;

//     return filteredItems.slice(start, end);
//   }, [page, filteredItems, rowsPerPage]);

//   const sortedItems = React.useMemo(() => {
//     return [...items].sort((a, b) => {
//       const first = a[sortDescriptor.column];
//       const second = b[sortDescriptor.column];
//       const cmp = first < second ? -1 : first > second ? 1 : 0;

//       return sortDescriptor.direction === "descending" ? -cmp : cmp;
//     });
//   }, [sortDescriptor, userLists, filteredItems]);

//   const renderCell = React.useCallback((user, columnKey) => {
//     switch (columnKey) {
//       case "name":
//         return (
//           <User
//             avatarProps={{ radius: "lg", src: "" }}
//             description={user.email}
//             name={`${user.first_name} ${user.last_name}`}
//           >
//             {user.email}
//           </User>
//         );
//       case "role":
//         return (
//           <div className="flex flex-col">
//             <p className="text-bold text-small capitalize">SUPPLIER</p>
//             <p className="text-bold text-tiny capitalize text-default-400">
//               {user.team}
//             </p>
//           </div>
//         );
//       case "phone":
//         return (
//           <div>
//             <p className="text-bold text-small capitalize">{user.phone}</p>
//           </div>
//         );
//       case "capricorn":
//         return (
//           <div>
//             <p className="text-bold text-small capitalize">
//               {user.is_capricorn_supplier ? "Yes" : "No"}
//             </p>
//           </div>
//         );
//       case "company":
//         return (
//           <div>
//             <p className="text-bold text-small capitalize">
//               {user.company_name}
//             </p>
//           </div>
//         );
//       case "actions":
//         return (
//           <div className="relative flex justify-start items-center gap-2">
//             {user.approval_status === "APPROVED" ||
//             user.approval_status === "REJECTED" ? (
//               <Chip
//                 className="capitalize"
//                 // color={statusColorMap[user.approval_status]}
//                 size="sm"
//                 variant="flat"
//                 classNames={{
//                   base: `${statusColorMap[user.approval_status]} text-white`,
//                 }}
//               >
//                 {user.approval_status}
//               </Chip>
//             ) : (
//               <>
//                 <Button
//                   className="!min-w-fit !text-sm bg-green-700 text-white font-medium"
//                   onPress={() => handleModal(user, "Approve")}
//                 >
//                   APPROVED
//                 </Button>
//                 <Button
//                   className="!min-w-fit !text-sm bg-red-700 text-white font-medium"
//                   onPress={() => handleModal(user, "Reject")}
//                 >
//                   REJECTED
//                 </Button>
//               </>
//             )}
//           </div>
//         );
//       default:
//         return user.first_name;
//     }
//   }, []);

//   const onRowsPerPageChange = React.useCallback((e) => {
//     setRowsPerPage(Number(e.target.value));
//     setPage(1);
//   }, []);

//   const onSearchChange = React.useCallback((value) => {
//     if (value) {
//       setFilterValue(value);
//       setPage(1);
//     } else {
//       setFilterValue("");
//     }
//   }, []);

//   const onClear = React.useCallback(() => {
//     setFilterValue("");
//     setPage(1);
//   }, []);

//   const topContent = React.useMemo(() => {
//     return (
//       <div className="flex flex-col gap-4">
//         <div className="flex justify-between gap-3 items-end">
//           <Input
//             isClearable
//             className="w-full sm:max-w-[44%]"
//             placeholder="Search by name..."
//             startContent={<IoSearchOutline />}
//             value={filterValue}
//             onClear={() => onClear()}
//             onValueChange={onSearchChange}
//           />
//         </div>
//         <div className="flex justify-between items-center">
//           <span className="text-default-400 text-small">
//             Total {paginationData.totalRecords} users
//           </span>
//           <label className="flex items-center text-default-400 text-small">
//             Rows per page:
//             <select
//               className="bg-transparent outline-none text-default-400 text-small"
//               // onChange={onRowsPerPageChange}

//               onChange={(e) => {
//                 setRowsPerPage(Number(e.target.value)); // 6, 10, or 15
//                 setPage(1); // always reset to page 1
//               }}
//             >
//               <option value="6">6</option>
//               <option value="10">10</option>
//               <option value="15">15</option>
//             </select>
//           </label>
//         </div>
//       </div>
//     );
//   }, [
//     filterValue,
//     visibleColumns,
//     onSearchChange,
//     onRowsPerPageChange,
//     hasSearchFilter,
//     paginationData,
//   ]);

//   const bottomContent = React.useMemo(() => {
//     return (
//       <div className="py-2 px-2 flex justify-center items-center">
//         <Pagination
//           isCompact
//           showControls
//           showShadow
//           color="primary"
//           page={paginationData.currentPage}
//           total={paginationData.totalPages}
//           onChange={setPage}
//         />
//       </div>
//     );
//   }, [userLists.length, page, hasSearchFilter]);

//   const getAllUsers = async () => {
//     try {
//       let res = await axios.get(
//         `${process.env.REACT_APP_SERVER_URL}/admin/supplierrequestlist?page=${page}&limit=${rowsPerPage}`
//       );
//       if (res) {
//         setPaginationData(res.data.details.index);
//         setUserLists(res.data.details.requests);
//       }
//     } catch (error) {
//       console.log(error);
//     }
//   };

//   useEffect(() => {
//     getAllUsers();
//   }, []);

//   return (
//     <div className="mb-14">
//       <Table
//         isHeaderSticky
//         bottomContent={bottomContent}
//         bottomContentPlacement="outside"
//         classNames={{
//           wrapper: "max-h-[382px]",
//         }}
//         sortDescriptor={sortDescriptor}
//         topContent={topContent}
//         topContentPlacement="outside"
//         onSortChange={setSortDescriptor}
//       >
//         <TableHeader columns={headerColumns}>
//           {(column) => (
//             <TableColumn
//               key={column.uid}
//               align={column.uid === "actions" ? "center" : "start"}
//               allowsSorting={column.sortable}
//             >
//               {column.name}
//             </TableColumn>
//           )}
//         </TableHeader>
//         <TableBody emptyContent={"No users found"} items={sortedItems}>
//           {(item) => (
//             <TableRow key={item.id}>
//               {(columnKey) => (
//                 <TableCell>{renderCell(item, columnKey)}</TableCell>
//               )}
//             </TableRow>
//           )}
//         </TableBody>
//       </Table>
//       {isOpen && (
//         <AccessModal
//           isOpen={isOpen}
//           onClose={onClose}
//           text={text}
//           handleSubmit={handleSubmit}
//         />
//       )}
//     </div>
//   );
// }

import React, { useCallback, useEffect, useMemo, useState } from "react";
import { toast } from "react-toastify";
import {
  Table,
  TableHeader,
  TableColumn,
  TableBody,
  TableRow,
  TableCell,
  Input,
  Button,
  Chip,
  User,
  Pagination,
  useDisclosure,
} from "@nextui-org/react";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import AccessModal from "./AccessModal";

export const columns = [
  { name: "ID", uid: "id", sortable: true },
  { name: "NAME", uid: "name" },
  { name: "ROLE", uid: "role" },
  { name: "EMAIL", uid: "email" },
  { name: "PHONE", uid: "phone" },
  { name: "CAPRICORN", uid: "capricorn" },
  { name: "COMPANY", uid: "company" },
  { name: "STATUS", uid: "status" },
  { name: "ACTIONS", uid: "actions" },
];

const statusColorMap = {
  PENDING: "success",
  APPROVED: "bg-green-600",
  REJECTED: "bg-red-500",
};

const INITIAL_VISIBLE_COLUMNS = [
  "name",
  "role",
  "phone",
  "capricorn",
  "company",
  "actions",
];

export default function RequestApproval() {
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [userLists, setUserLists] = useState([]);
  const [paginationData, setPaginationData] = useState({
    currentPage: 1,
    totalPages: 1,
    totalRecords: 0,
  });

  const [rowsPerPage, setRowsPerPage] = useState(6);
  const [page, setPage] = useState(1);
  const [filterValue, setFilterValue] = useState("");
  const [sortDescriptor, setSortDescriptor] = useState({
    column: "id",
    direction: "ascending",
  });
  const [visibleColumns] = useState(new Set(INITIAL_VISIBLE_COLUMNS));

  const [selectedUser, setSelectedUser] = useState(null);
  const [modalAction, setModalAction] = useState("");
  const computedTotalPages = filterValue ? 1 : paginationData.totalPages;
  const computedPage = filterValue ? 1 : page;

  const getAllUsers = useCallback(async () => {
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_SERVER_URL}/admin/supplierrequestlist`,
        { params: { page, limit: rowsPerPage } }
      );

      setUserLists(data.details.requests);
      setPaginationData(data.details.index);
      setPage(data.details.index.currentPage);
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message ?? "Couldn’t load users");
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    getAllUsers();
  }, [getAllUsers]);

  const headerColumns = useMemo(
    () =>
      visibleColumns === "all"
        ? columns
        : columns.filter((c) => visibleColumns.has(c.uid)),
    [visibleColumns]
  );

  const handlePageChange = (p) => {
    if (!filterValue) {
      setPage(p);
    } else {
      setPage(1);
    }
  };

  // 3️⃣ Reset back to page 1 whenever you start or clear a search
  const onFilterChange = (v) => {
    setFilterValue(v || "");
    setPage(1);
  };

  const filteredItems = useMemo(() => {
    if (!filterValue) return userLists;
    const q = filterValue.toLowerCase();
    return userLists.filter((u) =>
      `${u.first_name} ${u.last_name}`.toLowerCase().includes(q)
    );
  }, [filterValue, userLists]);

  const sortedItems = useMemo(() => {
    const items = [...filteredItems];
    const { column, direction } = sortDescriptor;
    items.sort((a, b) => {
      const first = a[column];
      const second = b[column];
      const cmp = first < second ? -1 : first > second ? 1 : 0;
      return direction === "descending" ? -cmp : cmp;
    });
    return items;
  }, [filterValue, sortDescriptor, userLists]);

  const renderCell = useCallback((user, columnKey) => {
    switch (columnKey) {
      case "name":
        return (
          <User
            avatarProps={{ radius: "lg", src: "" }}
            description={user.email}
            name={`${user.first_name} ${user.last_name}`}
          />
        );
      case "role":
        return (
          <div className="flex flex-col">
            <p className="text-bold text-small capitalize">SUPPLIER</p>
            <p className="text-bold text-tiny capitalize text-default-400">
              {user.team}
            </p>
          </div>
        );
      case "phone":
        return <p className="text-bold text-small">{user.phone}</p>;
      case "capricorn":
        return (
          <p className="text-bold text-small">
            {user.is_capricorn_supplier ? "Yes" : "No"}
          </p>
        );
      case "company":
        return <p className="text-bold text-small">{user.company_name}</p>;
      case "actions":
        return user.approval_status === "APPROVED" ||
          user.approval_status === "REJECTED" ? (
          <Chip
            size="sm"
            variant="flat"
            classNames={{
              base: `${statusColorMap[user.approval_status]} text-white`,
            }}
          >
            {user.approval_status}
          </Chip>
        ) : (
          <>
            <Button
              className="!min-w-fit !text-sm bg-green-700 text-white font-medium"
              onPress={() => {
                setSelectedUser(user);
                setModalAction("Approve");
                onOpen();
              }}
            >
              APPROVE
            </Button>
            <Button
              className="!min-w-fit !text-sm bg-red-700 text-white font-medium"
              onPress={() => {
                setSelectedUser(user);
                setModalAction("Reject");
                onOpen();
              }}
            >
              REJECT
            </Button>
          </>
        );
      default:
        return user[columnKey];
    }
  }, []);

  const handleStatusChange = async () => {
    if (!selectedUser) return;
    try {
      const approval_status =
        modalAction === "Approve" ? "APPROVED" : "REJECTED";
      await axios.put(
        `${process.env.REACT_APP_SERVER_URL}/admin/updatesupplierapproval/${selectedUser.id}`,
        { approval_status }
      );
      toast.success(
        `User ${modalAction === "Approve" ? "approved" : "rejected"}`
      );
      onClose();
      getAllUsers();
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message ?? "Update failed");
    }
  };

  const topContent = useMemo(
    () => (
      <div className="flex flex-col gap-4">
        <div className="flex justify-between gap-3 items-end">
          <Input
            isClearable
            className="w-full sm:max-w-[44%]"
            placeholder="Search by name..."
            startContent={<IoSearchOutline />}
            value={filterValue}
            onClear={() => setFilterValue("")}
            onValueChange={(v) => setFilterValue(v || "")}
          />
        </div>

        <div className="flex justify-between items-center">
          <span className="text-default-400 text-small">
            Total {paginationData.totalRecords} users
          </span>

          <label className="flex items-center text-default-400 text-small">
            Rows per page:
            <select
              value={rowsPerPage}
              className="bg-transparent outline-none ml-1"
              onChange={(e) => {
                setRowsPerPage(Number(e.target.value));
                setPage(1);
              }}
            >
              {[6, 10, 15].map((n) => (
                <option key={n} value={n}>
                  {n}
                </option>
              ))}
            </select>
          </label>
        </div>
      </div>
    ),
    [filterValue, paginationData.totalRecords, rowsPerPage]
  );

  const bottomContent = useMemo(
    () => (
      <div className="py-2 px-2 flex justify-center items-center">
        <Pagination
          isCompact
          showControls
          showShadow
          color="primary"
          // page={page}
          // total={paginationData.totalPages}
          // onChange={setPage}
          page={computedPage}
          total={computedTotalPages}
          onChange={handlePageChange}
        />
      </div>
    ),
    // [page, paginationData.totalPages]
    [computedPage, computedTotalPages]
  );

  return (
    <div className="mb-14">
      <Table
        isHeaderSticky
        topContent={topContent}
        topContentPlacement="outside"
        bottomContent={bottomContent}
        bottomContentPlacement="outside"
        sortDescriptor={sortDescriptor}
        onSortChange={setSortDescriptor}
        // classNames={{ wrapper: "max-h-[382px]" }}
      >
        <TableHeader columns={headerColumns}>
          {(column) => (
            <TableColumn
              key={column.uid}
              align={column.uid === "actions" ? "center" : "start"}
              allowsSorting={column.sortable}
            >
              {column.name}
            </TableColumn>
          )}
        </TableHeader>

        <TableBody emptyContent={"No users found"} items={sortedItems}>
          {(item) => (
            <TableRow key={item.id}>
              {(columnKey) => (
                <TableCell>{renderCell(item, columnKey)}</TableCell>
              )}
            </TableRow>
          )}
        </TableBody>
      </Table>

      {isOpen && (
        <AccessModal
          isOpen={isOpen}
          onClose={onClose}
          text={modalAction}
          handleSubmit={handleStatusChange}
        />
      )}
    </div>
  );
}
